module.exports = __webpack_public_path__ + "static/media/aw-whistledog-dt-fr.23d9fc82.jpg";